import {IS_WEB} from "@common/utils/mobileUtils";

export const boxedCardBorderStyle = {
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderRadius: 10
}